import { Outlet } from "react-router-dom";
import CustomNavbar from "./components/navbar";
import { SideNavigaton } from "./components/side-navigation";
export const DefaultComponents = () => {
  return (
    <>
      <CustomNavbar />
      <SideNavigaton />
      <Outlet />
    </>
  );
};
